const valid = value => value === "number" || value === "name";
const keyFor = userId => typeof userId === "string" && userId ? `transport-plant-sort:${encodeURIComponent(userId)}` : null;
export function readPlantSort(userId) {
  const key = keyFor(userId);
  if (!key) return "number";
  try { const value = window.localStorage.getItem(key); return valid(value) ? value : "number"; }
  catch { return "number"; }
}
export function rememberPlantSort(userId, value) {
  const key = keyFor(userId);
  if (!key || !valid(value)) return;
  try { window.localStorage.setItem(key, value); } catch { /* Sorting still works without browser storage. */ }
}
export function sortPlants(plants, order, lang) {
  const collator = new Intl.Collator(lang === "en" ? "en" : "de", { numeric: true, sensitivity: "base" });
  return [...plants].sort((a, b) => collator.compare(String(order === "name" ? a.name : a.kennung), String(order === "name" ? b.name : b.kennung))
    || String(a.key).localeCompare(String(b.key), "en", { sensitivity: "variant" }));
}
